import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { UserService } from '../../../layout/service/user.service';
import { DialogModule } from 'primeng/dialog';
import { PaginatorModule } from 'primeng/paginator';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
    selector: 'app-sheet-history',
    imports: [
        CommonModule,
        DialogModule,
        PaginatorModule,
        SkeletonModule,
    ],
    template: `
<div class="min-h-screen bg-gray-50 py-10 px-4">
    <div class="max-w-7xl mx-auto">
        <h2 class="text-3xl font-bold text-gray-900 mb-8 text-center">Riwayat Jawaban OSCE</h2>
        
        <!-- Loading State (Skeleton) -->
        <ng-container *ngIf="loading">
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
                <div *ngFor="let i of [1, 2, 3, 4, 5, 6]" class="bg-white rounded-lg shadow-md border border-gray-200 p-6">
                    <div class="flex items-center justify-between mb-4">
                        <p-skeleton width="100px" height="1.2rem"></p-skeleton>
                        <p-skeleton width="80px" height="1.5rem" borderRadius="16px"></p-skeleton>
                    </div>
                    <p-skeleton width="60%" height="1.5rem" styleClass="mb-4"></p-skeleton>
                    <div class="flex justify-between items-center">
                        <p-skeleton width="80px" height="1rem"></p-skeleton>
                        <p-skeleton width="100px" height="1.2rem"></p-skeleton>
                    </div>
                </div>
            </div>
        </ng-container>

        <!-- Main Content State -->
        <ng-container *ngIf="!loading">
            <ng-container *ngIf="forms.length > 0; else emptyHistory">
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
                <div *ngFor="let form of paginatedForms; let idx = index" class="bg-white rounded-lg shadow-md border border-gray-200 hover:shadow-lg transition-shadow cursor-pointer"
                    (click)="openDetail((currentPage - 1) * itemsPerPage + idx)">
                    <div class="p-6">
                        <div class="flex items-center justify-between mb-4">
                            <span class="text-sm text-gray-500">{{ addHours(form.created_at, 7) | date:'dd MMM yyyy, HH:mm' }}</span>
                            <span *ngIf="!isAssess(form)"
                                class="text-xs bg-yellow-100 text-yellow-800 px-2 py-1 rounded-full">
                                Belum dinilai
                            </span>
                            <span *ngIf="isAssess(form)"
                                class="text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full">
                                Sudah dinilai
                            </span>
                        </div>
                        <h3 class="text-lg font-semibold text-gray-900 mb-2">{{ form.sheet_case_name }}</h3>
                        <div class="flex justify-between items-center">
                            <span class="text-sm text-gray-600">Skor: {{ getScore(form) !== null ? getScore(form) : '-' }}</span>
                            <button class="text-blue-600 hover:text-blue-800 text-sm font-medium">
                                Lihat Detail →
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <p-paginator [first]="first" [rows]="itemsPerPage" [totalRecords]="forms.length" [rowsPerPageOptions]="[6, 12, 18]" (onPageChange)="onPageChange($event)"></p-paginator>
            <!-- Dialog for Detail -->
            <p-dialog [(visible)]="detailDialogOpen" maskStyleClass="backdrop-blur-sm" [modal]="true" [style]="{width: '95vw', maxWidth: '700px'}" [contentStyle]="{'padding':'0'}" [closable]="true" [dismissableMask]="true" (onHide)="closeDetail()">
                <ng-template #headless>
                    <ng-container *ngIf="detailIdx !== null && forms[detailIdx]">
                        <div class="bg-white rounded-lg overflow-hidden">
                            <!-- Dialog Header -->
                            <div class="bg-gray-100 px-6 py-4 border-b border-gray-200">
                                <h3 class="text-xl font-bold text-gray-900">{{ forms[detailIdx].sheet_case_name }}</h3>
                                <div class="flex flex-wrap gap-2 mt-2">
                                    <span class="text-sm bg-blue-100 text-blue-800 px-3 py-1 rounded-full">
                                        {{ addHours(forms[detailIdx].created_at, 7) | date:'dd MMM yyyy, HH:mm' }}
                                    </span>
                                    <span *ngIf="!isAssess(forms[detailIdx])"
                                        class="text-sm bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full">
                                        Belum dinilai
                                    </span>
                                    <span *ngIf="isAssess(forms[detailIdx])"
                                        class="text-sm bg-green-100 text-green-800 px-3 py-1 rounded-full">
                                        Sudah dinilai
                                    </span>
                                </div>
                            </div>
                            <!-- Dialog Body -->
                            <div class="p-6 space-y-6 max-h-[70vh] overflow-y-auto">
                                <div class="flex justify-between items-center">
                                    <span class="text-sm text-gray-600">Penguji: {{ forms[detailIdx].penguji && forms[detailIdx].penguji.trim() !== '' ? forms[detailIdx].penguji : '-' }}</span>
                                    <span class="text-lg font-bold text-yellow-600">Skor: {{ getScore(forms[detailIdx]) !== null ? getScore(forms[detailIdx]) : '-' }}</span>
                                </div>
                                <hr>
                                <div>
                                    <h4 class="text-lg font-semibold text-gray-900 mb-3">Pemeriksaan & Interpretasi</h4>
                                    <div class="space-y-3">
                                        <ng-container *ngFor="let key of pemeriksaanKeys(forms[detailIdx])">
                                            <ng-container *ngIf="key.includes('||'); else plainInterpretasiDialog">
                                                <ng-container [ngSwitch]="isTableKey(key)">
                                                    <ng-container *ngSwitchCase="true">
                                                        <div *ngIf="getTableData(forms[detailIdx], key).length > 0">
                                                            <h5 class="font-bold text-gray-900 mb-2">{{ getSheetName(key) }}</h5>
                                                            <div class="overflow-x-auto">
                                                                <table class="min-w-full bg-white border border-gray-300 rounded">
                                                                    <thead class="bg-gray-50">
                                                                        <tr>
                                                                            <th *ngFor="let header of getHeaderFromKey(key)" class="px-4 py-2 text-left text-sm font-semibold text-gray-700 border-b">
                                                                                {{ header }}
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <ng-container *ngFor="let row of getTableData(forms[detailIdx], key)">
                                                                            <tr class="hover:bg-gray-50">
                                                                                <td *ngFor="let cell of row" class="px-4 py-2 text-sm text-gray-700 border-b">
                                                                                    {{ cell }}
                                                                                </td>
                                                                            </tr>
                                                                        </ng-container>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                    <ng-container *ngSwitchDefault>
                                                        <div *ngIf="formPemeriksaan(forms[detailIdx], key)">
                                                            <h5 class="font-bold text-gray-900 mb-1">{{ getSheetName(key) }}</h5>
                                                            <div class="bg-gray-50 p-3 rounded border">
                                                                {{ formPemeriksaan(forms[detailIdx], key) }}
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>
                                            <ng-template #plainInterpretasiDialog>
                                                <div *ngIf="formPemeriksaan(forms[detailIdx], key)" class="flex flex-col md:flex-row gap-2">
                                                    <span class="bg-gray-100 text-gray-700 px-3 py-1 rounded font-medium min-w-[160px]">{{ key }}</span>
                                                    <span class="bg-white p-2 border rounded flex-1">{{ formPemeriksaan(forms[detailIdx], key) }}</span>
                                                </div>
                                            </ng-template>
                                        </ng-container>
                                    </div>
                                </div>
                                <hr>
                                <div>
                                    <h4 class="text-lg font-semibold text-gray-900 mb-3">Diagnosa</h4>
                                    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                                        <div class="bg-yellow-50 p-4 rounded border">
                                            <div class="text-sm font-bold text-yellow-800 mb-1">Diagnosa Utama</div>
                                            <div class="text-gray-800">{{ formDiagnosa(forms[detailIdx], 'diagnosaUtama') }}</div>
                                        </div>
                                        <div class="bg-yellow-50 p-4 rounded border">
                                            <div class="text-sm font-bold text-yellow-800 mb-1">Diagnosa Banding 1</div>
                                            <div class="text-gray-800">{{ formDiagnosa(forms[detailIdx], 'diagnosaBanding1') }}</div>
                                        </div>
                                        <div class="bg-yellow-50 p-4 rounded border">
                                            <div class="text-sm font-bold text-yellow-800 mb-1">Diagnosa Banding 2</div>
                                            <div class="text-gray-800">{{ formDiagnosa(forms[detailIdx], 'diagnosaBanding2') }}</div>
                                        </div>
                                    </div>
                                </div>
                                <hr>
                                <div>
                                    <h4 class="text-lg font-semibold text-gray-900 mb-3">Resep</h4>
                                    <ul class="list-disc pl-6 space-y-1">
                                        <li *ngFor="let resep of formResep(forms[detailIdx])" class="text-gray-800">
                                            <span class="font-bold text-blue-600">R/</span> {{ resep }}
                                        </li>
                                    </ul>
                                </div>
                                <ng-container *ngIf="forms[detailIdx].sheet_details && forms[detailIdx].sheet_details.length > 0">
                                    <hr>
                                    <div>
                                        <h4 class="text-lg font-semibold text-gray-900 mb-3">Detail Sheet</h4>
                                        <div class="space-y-2">
                                            <div *ngFor="let detail of forms[detailIdx].sheet_details" class="bg-purple-50 p-3 rounded border">
                                                <div class="text-sm text-gray-700">
                                                    <strong class="font-medium text-purple-700">{{ detail.name || 'Detail' }}:</strong>
                                                    <div *ngIf="detail.content" class="mt-2">
                                                        <ng-container *ngFor="let item of parseContent(detail.content); let i = index">
                                                            <div *ngIf="item" [innerHTML]="item" class="mb-2"></div>
                                                        </ng-container>
                                                    </div>
                                                    <div *ngIf="!detail.content">-</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>

                                <!-- Rubric Score Details -->
                                <ng-container *ngIf="rubricLoading">
                                    <hr>
                                    <div class="flex justify-center items-center py-6">
                                        <i class="pi pi-spin pi-spinner text-2xl text-blue-600 mr-2"></i>
                                        <span class="text-gray-600 font-medium">Memuat hasil penilaian rubrik...</span>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="!rubricLoading && rubricDetails && rubricDetails.length > 0">
                                    <hr>
                                    <div>
                                        <h4 class="text-lg font-semibold text-gray-900 mb-3 flex items-center gap-2">
                                            <i class="pi pi-check-square text-green-600"></i>
                                            Hasil Penilaian Rubrik
                                        </h4>
                                        <div class="overflow-x-auto border border-gray-200 rounded-lg shadow-sm">
                                            <table class="min-w-full divide-y divide-gray-200">
                                                <thead class="bg-gray-50">
                                                    <tr>
                                                        <th scope="col" class="px-3 py-3 text-center text-xs font-bold text-gray-500 uppercase tracking-wider w-12 border-b">No</th>
                                                        <th scope="col" class="px-4 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wider border-b">Kegiatan</th>
                                                        <th scope="col" class="px-3 py-3 text-center text-xs font-bold text-gray-500 uppercase tracking-wider w-16 border-b">Skor</th>
                                                        <th scope="col" class="px-4 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wider border-b">Komentar</th>
                                                    </tr>
                                                </thead>
                                                <tbody class="bg-white divide-y divide-gray-200">
                                                    <tr *ngFor="let item of rubricDetails" [ngClass]="{'bg-gray-50/50 font-semibold': item.IS_HEADER === '1'}">
                                                        <td class="px-3 py-2.5 text-center text-sm text-gray-500 border-b" [innerHTML]="item.IS_HEADER === '1' ? '' : item.NO"></td>
                                                        <td class="px-4 py-2.5 text-sm text-gray-950 border-b" [innerHTML]="item.ACTIVITY"></td>
                                                        <td class="px-3 py-2.5 text-center text-sm border-b">
                                                            <span *ngIf="item.IS_HEADER !== '1'" class="inline-flex items-center justify-center w-7 h-7 rounded-full text-xs font-extrabold"
                                                                [ngClass]="{
                                                                    'bg-green-100 text-green-800 border border-green-300': getRubricItemScore(item) === '3',
                                                                    'bg-blue-100 text-blue-800 border border-blue-200': getRubricItemScore(item) === '2',
                                                                    'bg-yellow-100 text-yellow-800 border border-yellow-200': getRubricItemScore(item) === '1',
                                                                    'bg-red-100 text-red-800 border border-red-300': getRubricItemScore(item) === '0'
                                                                }">
                                                                {{ getRubricItemScore(item) }}
                                                            </span>
                                                        </td>
                                                        <td class="px-4 py-2.5 text-sm text-gray-600 border-b" [innerHTML]="item.KOMENTAR || '-'"></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </ng-container>
                </ng-template>
            </p-dialog>
        </ng-container>
    </ng-container>
        <ng-template #emptyHistory>
            <div class="flex flex-col items-center justify-center py-24">
                <i class="pi pi-inbox text-6xl text-gray-300 mb-4"></i>
                <div class="text-xl text-gray-900 font-semibold mb-2">Belum ada riwayat jawaban OSCE</div>
                <div class="text-gray-500">Jawaban yang sudah Anda kumpulkan akan tampil di sini.</div>
            </div>
        </ng-template>
    </div>
</div>
`,
})
export class SheetHistory implements OnInit {
    isAdmin = false;
    isTutor = false;
    forms: any[] = [];
    userStr: string | null = null;
    detailDialogOpen: boolean = false;
    detailIdx: number | null = null;
    currentPage: number = 1;
    itemsPerPage: number = 6;
    first: number = 0;
    loading: boolean = false;
    rubricDetails: any[] = [];
    rubricLoading: boolean = false;

    constructor(
        private userService: UserService,
        private router: Router
    ) {
        this.userStr = localStorage.getItem('user');
        if (this.userStr) {
            try {
                const user = JSON.parse(this.userStr);
                this.isAdmin = user.ID_ACCESS_ROLE === 'N2FWBVCZUE';
                this.isTutor = user.ID_ACCESS_ROLE === '4AEJ1KAJTY';
            } catch (e) {
                this.isAdmin = false;
                this.isTutor = false;
            }
        }
    }

    ngOnInit() {
        const user = this.userStr ? JSON.parse(this.userStr) : null;
        const userId = user?.ID_USER || user?.id || '';
        if (!userId) {
            this.forms = [];
            return;
        }

        this.loading = true;
        // Fetch sheet answers, packages, and admin OSCE results
        Promise.all([
            this.userService.getSheetAnswer({ user_id: userId }),
            this.userService.getPackageSimulation().catch(() => ({ data: [] })),
            this.userService.getOsceResult().catch(() => ({ data: [] }))
        ]).then(([sheetRes, pkgRes, osceResultRes]) => {
            let sheetAnswers = sheetRes.status && Array.isArray(sheetRes.data) ? sheetRes.data : [];
            const packages = pkgRes.data || [];
            const osceResults = Array.isArray(osceResultRes?.data) ? osceResultRes.data :
                               (osceResultRes?.data ? Object.values(osceResultRes.data) : []);

            // Fetch simulation answers for each package
            const simPromises = packages.map((pkg: any) => 
                this.userService.simulationUserAnswer({ user_id: userId, package_id: pkg.id })
                    .then((res: any) => res.data || [])
                    .catch(() => [])
            );

            Promise.all(simPromises).then((simAnswersNested) => {
                const simAnswers = simAnswersNested.flat();
                const mappedReports = new Set<any>();

                // Filter osceResults for current user
                const userOsceResults = osceResults.filter((res: any) => 
                    String(res.USER_ID || res.user_id || res.ID_USER || '') === String(userId) ||
                    String(res.MAHASISWA || '').toLowerCase() === String(user?.FULLNAME || user?.name || '').toLowerCase()
                );

                sheetAnswers = sheetAnswers.map((form: any) => {
                    let updatedForm = { ...form };
                    const scoreVal = this.getScore(updatedForm);
                    const formTime = new Date(form.created_at).getTime();
                    const MAX_DIFF_MS = 15 * 60 * 1000;

                    // 1. Try matching with admin/tutor evaluated reports (getOsceResult)
                    const osceCandidates = userOsceResults.filter((res: any) => 
                        !mappedReports.has(res) &&
                        (
                            String(res.ID_OSCE || res.osce_id || '') === String(updatedForm.osce_id || updatedForm.ID_OSCE || '') ||
                            String(res.JUDUL || '').toLowerCase() === String(updatedForm.sheet_case_name || '').toLowerCase()
                        )
                    );

                    let bestOsceMatch: any = null;
                    let minOsceDiff = Infinity;
                    osceCandidates.forEach((res: any) => {
                        const timeStr = res.CREATED_AT || res.created_at;
                        if (timeStr) {
                            const resTime = new Date(timeStr).getTime();
                            if (!isNaN(resTime)) {
                                const diff = Math.abs(formTime - resTime);
                                if (diff < minOsceDiff) {
                                    minOsceDiff = diff;
                                    bestOsceMatch = res;
                                }
                            }
                        } else if (minOsceDiff === Infinity) {
                            bestOsceMatch = res;
                        }
                    });

                    if (bestOsceMatch && (minOsceDiff <= MAX_DIFF_MS || minOsceDiff === Infinity)) {
                        updatedForm.score = bestOsceMatch.SKOR !== undefined && bestOsceMatch.SKOR !== null ? bestOsceMatch.SKOR : bestOsceMatch.score;
                        updatedForm.reportId = bestOsceMatch.ID_REPORT || bestOsceMatch.id;
                        updatedForm.penguji = bestOsceMatch.CREATED_BY || bestOsceMatch.penguji || updatedForm.penguji || 'Admin / Tutor';
                        mappedReports.add(bestOsceMatch);
                        return updatedForm;
                    }

                    // 2. Try matching with simulation answers if no tutor report match
                    const simCandidates = simAnswers.filter((sim: any) => 
                        !mappedReports.has(sim) &&
                        String(sim.ID_OSCE || sim.osce_id) === String(updatedForm.osce_id || updatedForm.ID_OSCE) &&
                        String(sim.USER_ID || sim.user_id) === String(updatedForm.user_id || updatedForm.ID_USER || userId)
                    );

                    let bestSimMatch: any = null;
                    let minSimDiff = Infinity;
                    simCandidates.forEach((sim: any) => {
                        const simTimeStr = sim.CREATED_AT || sim.created_at;
                        if (simTimeStr) {
                            const simTime = new Date(simTimeStr).getTime();
                            if (!isNaN(simTime)) {
                                const diff = Math.abs(formTime - simTime);
                                if (diff < minSimDiff) {
                                    minSimDiff = diff;
                                    bestSimMatch = sim;
                                }
                            }
                        }
                    });

                    if (bestSimMatch && minSimDiff <= MAX_DIFF_MS) {
                        if (scoreVal === null || scoreVal === undefined || scoreVal === '') {
                            updatedForm.score = bestSimMatch.SKOR !== undefined && bestSimMatch.SKOR !== null ? bestSimMatch.SKOR : bestSimMatch.score;
                        }
                        updatedForm.reportId = bestSimMatch.ID_REPORT || bestSimMatch.id;
                        if (!updatedForm.penguji || updatedForm.penguji.trim() === '') {
                            updatedForm.penguji = 'System (Simulasi)';
                        }
                        mappedReports.add(bestSimMatch);
                    }

                    return updatedForm;
                });

                this.forms = sheetAnswers.sort((a: any, b: any) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
                this.loading = false;
            });
        }).catch(() => {
            this.forms = [];
            this.loading = false;
        });
    }

    get paginatedForms(): any[] {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return this.forms.slice(start, end);
    }

    onPageChange(event: any) {
        this.first = event.first;
        this.currentPage = event.page + 1;
        this.itemsPerPage = event.rows;
    }

    pemeriksaanKeys(form: any): string[] {
        try {
            const obj = JSON.parse(form.pemeriksaan || '{}');
            return Object.keys(obj);
        } catch {
            return [];
        }
    }

    formPemeriksaan(form: any, key: string): string {
        try {
            const obj = JSON.parse(form.pemeriksaan || '{}');
            return obj[key] || '-';
        } catch {
            return '-';
        }
    }

    formDiagnosa(form: any, key: string): string {
        try {
            const obj = JSON.parse(form.diagnosa || '{}');
            return obj[key] || '-';
        } catch {
            return '-';
        }
    }

    formResep(form: any): string[] {
        try {
            return JSON.parse(form.resep || '[]');
        } catch {
            return [];
        }
    }

    isTableKey(key: string): boolean {
        if (!key.includes('||')) return false;
        const header = key.split('||')[1];
        try {
            const parsed = JSON.parse(header);
            return Array.isArray(parsed);
        } catch {
            return false;
        }
    }

    getHeaderFromKey(key: string): string[] {
        if (!key.includes('||')) return [];
        const header = key.split('||')[1];
        try {
            const parsed = JSON.parse(header);
            return Array.isArray(parsed) ? parsed : [];
        } catch {
            return [];
        }
    }

    getTableData(form: any, key: string): any[][] {
        try {
            const obj = JSON.parse(form.pemeriksaan || '{}');
            const value = obj[key] || '';
            
            if (!value || value === '') {
                return [];
            }
            
            try {
                const parsed = JSON.parse(value);
                if (Array.isArray(parsed)) {
                    return parsed;
                }
            } catch {
                // Not a JSON array
            }
            
            const headers = this.getHeaderFromKey(key);
            if (headers.length > 0) {
                const row = new Array(headers.length).fill('');
                row[0] = value;
                return [row];
            }
            
            return [];
        } catch {
            return [];
        }
    }

    getSheetName(key: string): string {
        return key.split('||')[0];
    }

    openDetail(idx: number) {
        this.detailIdx = idx;
        this.detailDialogOpen = true;
        this.rubricDetails = [];
        const form = this.forms[idx];
        const reportId = form?.reportId || form?.ID_REPORT || form?.report_id || form?.id;

        if (form && reportId) {
            this.rubricLoading = true;
            const promise = form.penguji === 'System (Simulasi)'
                ? this.userService.getSimulationUserDetails({ ID_REPORT: reportId })
                : this.userService.detailOsceResult({ ID_REPORT: reportId });

            promise.then((res: any) => {
                if (res && res.data) {
                    const data = Array.isArray(res.data) ? res.data : Object.values(res.data);
                    this.rubricDetails = data;
                }
            }).catch((err) => {
                console.error('Error fetching rubric details:', err);
                this.rubricDetails = [];
            }).finally(() => {
                this.rubricLoading = false;
            });
        }
    }

    closeDetail() {
        this.detailDialogOpen = false;
        this.detailIdx = null;
        this.rubricDetails = [];
    }

    parseContent(content: string): string[] {
        try {
            return JSON.parse(content);
        } catch {
            return [];
        }
    }

    addHours(dateString: string, hours: number): Date {
        const date = new Date(dateString);
        date.setHours(date.getHours() + hours);
        return date;
    }

    getScore(form: any): any {
        if (!form) return null;
        if (form.score !== null && form.score !== undefined) {
            return form.score;
        }
        if (form.skor !== null && form.skor !== undefined) {
            return form.skor;
        }
        if (form.SKOR !== null && form.SKOR !== undefined) {
            return form.SKOR;
        }
        return null;
    }

    getRubricItemScore(item: any): string {
        if (!item) return '0';
        const val = item.BOBOT !== undefined && item.BOBOT !== null ? item.BOBOT :
                    (item.bobot !== undefined && item.bobot !== null ? item.bobot :
                    (item.SKOR !== undefined && item.SKOR !== null ? item.SKOR :
                    (item.skor !== undefined && item.skor !== null ? item.skor :
                    (item.score !== undefined && item.score !== null ? item.score :
                    (item.SCORE !== undefined && item.SCORE !== null ? item.SCORE : '0')))));
        const num = Number(val);
        return isNaN(num) ? '0' : String(Math.round(num));
    }

    isAssess(form: any): boolean {
        if (!form) return false;
        const score = this.getScore(form);
        if (score !== null && score !== undefined && score !== '') {
            return true;
        }
        if (form.penguji && form.penguji.trim() !== '') {
            return true;
        }
        return false;
    }
}
